import React, { Component } from 'react';

import {
	Grid,
	Divider,
	Segment,
	Card, 
	Icon,
	Image,
	Container,
	Header
} from 'semantic-ui-react';

/*
 * TODO: when we have them:
 * 	- awards
 * 	- videos
 * 	- various photos
 * 	- press articles
 */
export class Press extends Component {

	companyFacts() {
		return (
			<Container>
				<Segment basic size='large'>
					<Header size='huge'>Company Facts</Header>
					<p>Captivate Games is an independent video game company founded in April 2017.</p>
					<p>We are based in the United States with team members in Colorado, Pennsylvania, and New York.</p>
				</Segment>
			</Container>
		);
	}

	whoWeAre() {
		return (
			<Container>
				<Segment basic size='large'>
					<Header size='huge'>Who We Are</Header>
					<p>Our north star at Captivate Games is to create games that are fun, unique, and engaging.</p>
					<p>Our biggest role models are Nintendo and Blizzard.</p>
					<p>We make games because they have the power to make lasting impressions, tell great stories, bring people together, create smiles, and make life better.</p>
					<p>We will treat all stakeholders fairly and with respect.</p>
				</Segment>
			</Container>
		);
	}

	whatWeBelieve() {
		return (
			<Container>
				<Segment basic size='large'>
					<Header size='huge'>What We Believe</Header>
					<p>Success will be measured by more than revenue and profits.</p>
					<p>We value providing:</p>

					<ul>
						<li>a great company for employees</li>
						<li>great products and services for customers</li>
						<li>long-term growth and transparency for investors and partners</li>
					</ul>

					<p>We are long-term oriented and ignore day-to-day distractions.</p>
					<p>Things that are worthwhile are often hard.</p>
					<p>We will not dwell on past successes or failures. Each day is an opportunity to do the best work we can.</p>
					<p>A strong team is precious and we will be vigilant guardians of a positive, productive, and forward-looking team culture.</p>
				</Segment>
			</Container>
		);
	}

	ourGames() {
		return (
			<Container>
				<Segment basic size='large'>
					<Header size='huge'>Games</Header>
					<Divider hidden />
					<Card.Group stackable itemsPerRow={2}>
						<Card raised image='../grid_caster_bk_logo.png' href='/gridcaster' />
					</Card.Group>
				</Segment>
			</Container>
		);
	}

	founders() {
		return (
			<Container>
				<Segment basic size='large'>
					<Header size='huge'>Founders</Header>
					<Card.Group doubling itemsPerRow={4}>
						<Card>
							<Image src='../profiles/mike_profile.jpg' centered size='large' />
							<Card.Content>
								<Card.Header>Mike Dwyer</Card.Header>
								<Card.Meta>Co-founder</Card.Meta>
								<Card.Description>
									<a href='https://www.linkedin.com/in/michaelgdwyer/'>
										<Icon name='linkedin square' size='large' />
									</a>
									<a href='https://github.com/dumaike'>
										<Icon name='github' size='large' />
									</a>
								</Card.Description>
							</Card.Content>
						</Card>
						<Card>
							<Image src='../profiles/tommy_profile.jpg' centered size='large' />
							<Card.Content>
								<Card.Header>Tommy Leung</Card.Header>
								<Card.Meta>Co-founder</Card.Meta>
								<Card.Description>
									<a href='https://www.linkedin.com/in/supertommy/'>
										<Icon name='linkedin square' size='large' />
									</a>
									<a href='https://github.com/supertommy'>
										<Icon name='github' size='large' />
									</a>
									<a href='https://twitter.com/iamSuperTommy'>
										<Icon name='twitter' size='large' />
									</a>
								</Card.Description>
							</Card.Content>
						</Card>
					</Card.Group>
				</Segment>
			</Container>
		);
	}

	companyLogos() {
		return (
			<Container>
				<Segment basic size='large'>
					<Header size='huge'>Logos</Header>
					<Image src='../logos/captivate_logo_black.png' size='huge' />
					<Image src='../logos/captivate_logo_blue.png' size='huge' />
					<Image src='../logos/captivate_logo_red.png' size='huge' />
					<Image src='../logos/captivate_logo_green.png' size='huge' />
					<Image src='../logos/captivate_logo_yellow.png' size='huge' />
				</Segment>
			</Container>
		);
	}

	pressContact() {
		return (
			<Container>
				<Segment basic size='large'>
					<p>For press inquiries, please contact <a href='mailto:tommy@captivate.games'>Tommy Leung</a></p>
				</Segment>
			</Container>
		);
	}

	render() {
		return (
			<div>
				<div className='about-header ui vertical masthead'>
					<div className='ui center aligned text container'>
						<Image src={this.props.logo} />
					</div>
				</div>
				<Divider hidden />
				<Grid>
					<Grid.Row>
						<Grid.Column width={16}>
							{this.companyFacts()}
						</Grid.Column>
						<Grid.Column width={16}>
							{this.whoWeAre()}
						</Grid.Column>
						<Grid.Column width={16}>
							{this.whatWeBelieve()}
						</Grid.Column>
						<Grid.Column width={16}>
							{this.ourGames()}
							<Divider hidden />
						</Grid.Column>
						<Grid.Column width={16}>
							{this.founders()}
							<Divider hidden />
						</Grid.Column>
						<Grid.Column width={16}>
							{this.companyLogos()}
							<Divider hidden />
						</Grid.Column>
						<Grid.Column width={16}>
							{this.pressContact()}
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Press/Press.js